import gql from "graphql-tag";

import { getClient } from '../../api/graphql'
import { ValidationError } from '../../types/types'

type GraphqlSignupResponse = {
  newslettersignup: NewsletterSignupResponse
}

type GraphqlVariables = {
  input: SignupNewsletterInput
}

export type NewsletterSignupResponse = {
  success:boolean,
  errors?: ValidationError[]
}

export type SignupNewsletterInput = {
  email: string
  name: string
  recaptcharesponse: string
}

export const NewsletterSignup = async (input : SignupNewsletterInput) : Promise<NewsletterSignupResponse> => {
  const result = await getClient().mutate<GraphqlSignupResponse, GraphqlVariables>({
    mutation: gql`
      mutation newslettersignup($input: NewsletterSignupMutationInput!) {
        newslettersignup(input: $input) {
          success
          errors{
            path
            message
          }
        }
      }
    `,
    variables: {
      input: input
    }
  });

  // Typing for this is dodgy
  // See https://github.com/apollographql/apollo-client/issues/2795

  return result.data.newslettersignup as NewsletterSignupResponse;
}
